import { useState } from "react"
import { OffsegAuthInfoType } from "../../feature/type/AuthInfoType"
import { initOffsegAuthInfo } from "../../../common/const/commonConst";

/**
 * 再登録時に入力するOffsegログイン情報の状態管理用カスタムフック
 */
export const useStateOffsegReregistrationAuthInfo = () => {
    const [offsegReregistrationAuthInfo, setOffsegReregistrationAuthInfo] = useState<OffsegAuthInfoType>(initOffsegAuthInfo);

    return {
        offsegReregistrationAuthInfo,
        setOffsegReregistrationAuthInfo
    }
}